import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateFormatter, registryLinkFormatter } from '../../../utils/formatters';
import { REGISTRY_TYPE } from '../../../configs';
import Switches from '../../../components/fields/Switches/Switches';
import { getPaginationOpts, responseLogWithNotification } from '../../../utils/utils';
import {
  loadRelationCarrierVehicleClear,
  loadRelationCarrierVehicleList,
  loadRelationVehicleSzltList,
  loadRelationVehicleSzltListClear,
} from '../actions';
import { getRegisterData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import RegistryPageModal from './RegistryPageModal';
import getDefaultSort from '../../../utils/getDefaultSort';

export default function VehiclesMiniGrid(props) {
  const { setIsHistoryPopUp = () => {}, isCarrierRelationType = true, params = {} } = props;
  const dispatch = useDispatch();
  const [isRegistryModal, setIsRegistryModal] = useState(false);
  const {
    relationCarrierVehicleList = [],
    relationCarrierVehicleListMeta = {},
    relationVehicleSzltList = [],
    relationVehicleSzltListMeta = {},
    loadingRelationCarrierVehicleList,
    loadingRelationVehicleSzltList,
  } = useSelector(getRegisterData);

  const action = isCarrierRelationType ? loadRelationCarrierVehicleList : loadRelationVehicleSzltList;
  const currentList = isCarrierRelationType ? relationCarrierVehicleList : relationVehicleSzltList;
  const currentMeta = isCarrierRelationType ? relationCarrierVehicleListMeta : relationVehicleSzltListMeta;
  const loading = isCarrierRelationType ? loadingRelationCarrierVehicleList : loadingRelationVehicleSzltList;

  useEffect(() => {
    if (isCarrierRelationType) {
      dispatch(loadRelationCarrierVehicleClear());
      return;
    }
    dispatch(loadRelationVehicleSzltListClear());
  }, []);

  const {
    getValues, control, watch,
  } = useForm({});

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(currentMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: {
        ...params,
        ...filterData,
      },
      sort,
    };
    const p1 = dispatch(action(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    dispatch(action({ filter: { ...params } })).catch(responseLogWithNotification);
  }, []);

  const vehiclesColumns = [
    {
      dataField: 'vehicle',
      sortField: 'registry_id',
      text: 'Номер записи',
      formatter: item => registryLinkFormatter(item?.number, REGISTRY_TYPE.VEHICLE, { registry_id: item?.id }),
    },
    {
      dataField: 'vehicle',
      sortField: 'effective_date',
      headerClassName: 'effective-date',
      text: 'Дата включения',
      formatter: (_, item) => dateFormatter(item?.effective_date),
    },
    {
      dataField: 'vehicle',
      sortField: 'expiration_date',
      text: 'Дата исключения',
      formatter: (_, item) => dateFormatter(item?.expiration_date),
    },
    {
      dataField: 'vehicle',
      sortField: 'is_active',
      text: 'Статус связи',
      formatter: (_, item) => (item?.is_active ? 'Действующая' : 'Недействующая'),
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(vehiclesColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  return (
    <div className="afc-data">
      <div className="afc-wrapper">
        <div className="afc-header">
          <div className="afc-header-text">
            Связи с реестром легковых такси
          </div>
          <FieldDTO
            type="text"
            control={control}
            component={Switches}
            dtoObject={{
              name: 'only_active',
              type: String,
              validators: [],
              labelKey: 'registry.isAvailable',
            }}
            variant="material"
          />
          <div className="table-control-button">
            <div
              className={classNames('link-text', { disabled: !currentList?.length })}
              onClick={currentList?.length && (() => setIsRegistryModal(true))}
            > <Icons
              customIcon
              icon="same-registry"
            />
            </div>
            {isCarrierRelationType ? (
              <Icons
                customIcon
                className="history-icon"
                icon="history-relation"
                onClick={() => setIsHistoryPopUp('vehicle')}
              />
            ) : null}
          </div>
        </div>
        <div className="afc-body">
          <div className="grid-wrapper">
            <div className=" custom-scroll-theme">
              <Grid
                data={currentList}
                changeSort={changeSort}
                sort={sort}
                columns={vehiclesColumns}
                loading={loading}
              />
            </div>
            <Pagination
              meta={currentMeta}
              list={currentList}
              handleChangeMeta={loadData}
            />
          </div>
        </div>
      </div>
      {
        isRegistryModal ? (
          <RegistryPageModal
            type="passenger-taxi"
            customFilter={{
              numbers: (currentList || []).map(i => i?.vehicle.number),
            }}
            onClose={() => setIsRegistryModal(false)}
          />
        ) : null
      }
    </div>
  );
}
